<template>
  <div class="home">
    <!-- <h2>这是home.vue页面</h2> -->
    <div id="MyViewerDiv"></div>
  </div>
</template>

<script>
// import {} from "@/setAxios";
export default {
  name: "viewModel",
  components: {},
  props: ["url"],
  data() {
    return { viewer: null };
  },
  methods: {
    viewers(link, url) {
      var _this = this;
      //初始化
      var config = {
        extensions: ["Autodesk.Viewing.ZoomWindow"],
        disabledExtensions: {
          measure: false,
          section: false,
        },
        memory: {
          limit: 32 * 1024, //32 GB
        },
      };
      var myViewerDiv = document.getElementById("MyViewerDiv");
      _this.viewer = new Autodesk.Viewing.Viewer3D(myViewerDiv, config);
      var options = {
        language: "zh-HANS",
        env: "Local",
        offline: "true",
        useADP: false,
      };
      Autodesk.Viewing.Initializer(options, function onInitialized() {
        _this.viewer.start();
        const modelOpts = {
          applyRefPoint: true,
          globalOffset: {
            x: 0,
            y: 0,
            z: 0,
          },
        };
        if (Array.isArray(url)) {
          url.forEach((ele) => {
            _this.viewer.loadModel(
              link + (ele.mode09 || ele.gdpm05 || ele.mtma05),
              modelOpts
            );
          });
        }else{
          _this.viewer.loadModel(
            link + url,
            modelOpts
          );
        }
      });
      _this.viewer.addEventListener(
        Autodesk.Viewing.TEXTURES_LOADED_EVENT,
        function(event) {
          _this.viewer.setBackgroundColor(3, 12, 26, 3, 12, 26);
        }
      );
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.viewers(this.$store.state.baseUrl, this.url);
    }, 1000);
  },
};
</script>

<style lang="less" scoped>
#MyViewerDiv {
  position: absolute !important;
  width: 100%;
  height: 100%;
  z-index: 0;
  top: 0;
  left: 0;
}
</style>
